<template>
	<div ref="authCreate" class="dialog-container">
		<div class="dialog" style="max-height: 560px; transform: translate(0, -280px);">
			<form @submit.stop="doValidation()">
				<div class="top">
					<p class="txt-crud-title">
						Emr Data Create
					</p> 
				</div>
				<div class="center">
					<table class="tb-crud-horizon">
						<colgroup>
							<col width="35%" />
							<col width="15%" />
							<col width="25%" />
							<col width="25%" />
						</colgroup>
						<tbody>
							<tr>
								<th>
									Project
								</th>
								<td  colspan="3">
									<select 
										class="select-crud"
										style="max-width: 100%;"
										v-model="item.projectNo"
										@change="searchColumn()"
									>
										<option value="" selected disabled>--- select project ---</option>
										<option v-for="(item, index) in projectList" :key="index" :value="item.projectNo">
											{{ "(V"+item.projectVersion+")" + item.projectStudyTitle }}
										</option>
									</select>
								</td>
							</tr>
							<tr 
								v-for="(col, colIndex) in columnList"
								:key="colIndex"
							>
								<th>
									{{col.columnEnglishName}}
								</th>
								<td colspan="3">
									<input
										type="text"
										class="input-crud"
										:name="'COLUMN_'+col.columnNo"
										v-model="dataList[colIndex].dataValue"
									/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-save fright" title="Save" @click.stop="doValidation()">
						Save
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "EmrDataCreate",
	created() {
		this.logger.debug(this, "created()");
		this.item.firstRegistDate = moment().format("YYYY-MM-DD");
		this.item.firstRegistUserId = this.userInfo.userId;
		this.item.firstRegistUserName = this.userInfo.userName;
		// this.selectColumnList();
		this.item.projectNo = "";
		this.selectEmrProjectList();
	},
	data() {
		return {
			item: {},
			columnList : [],
			projectList: [],
			dataList : [],
			valueList : [],
		};
	},
	methods: {
		selectEmrProjectList(){
			this.logger.debug(this, "selectEmrProjectList()");
			axios
				.post(this.config.contextRoot + "/emr/selectEmrProjectList.do", this.item)
				.then((response) => {
					console.log(response);
					this.projectList = response.data.projectList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectColumnList() {         
			this.logger.debug(this, "selectColumnList()");
			axios
				.post(this.config.contextRoot + "/emr/selectColumnAllList.do", this.item)
				.then((response) => {
					console.log(response); 
					this.columnList = response.data.selectColumnAllList;
					for(let i = 0 ; i < this.columnList.length ; i++)
					{
						let data = {
							projectNo : this.item.projectNo,
							dataColumnNo: this.columnList[i].columnNo,
							dataValue: "",
							dataType : "TYPING",
						};
						this.dataList.push(data);
					}
					/* this.pagination = response.data.pagination;
					this.$nextTick(function () {
						setTimeout(function() {
							EventBus.$emit("setting-loading", false);
						}.bind(this), 500);
					}); */
				})
				.catch((error) => {
					this.exceptionHandler(this, error); 
				});
		},
		searchColumn() {
			this.$set(this.item, "searchProjectNo", this.item.projectNo);
			this.dataList = [];
			this.selectColumnList();
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			if(this.item.projectNo == ''){
				this.$alert("select project" ,"Warn","warning");
				return false;
			}
			if(this.columnList.length <= 0){
				this.$alert("Please add a column" ,"Warn","warning");
				return false;
			}
			let valueList = this.dataList.filter((item) => {
				return item.dataValue.replace(/(\s*)/g, "") != "";
			});
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current data?", "Question", "question").then(() => {
							EventBus.$emit("setting-loading", true);
							this.doInsert(valueList);
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doInsert(valueList) {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/emr/insertData.do", valueList)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						location.reload();
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the auth registration?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.authCreate.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.authCreate.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("setting-cancel", "isAuthCreate");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
</style>